export default __webpack_public_path__ + "static/media/helpTransInfo.23269b3f.png";